var gql = require("@apollo/client").gql;

const TARIFF_IN_ANTI_FILTER = gql`
	query TariffInAntiFilter(
		$id: Int
		$region: String
		$providerId: Int
		$internet: Int
		$calls: Int
		$price: Int
		$fix: String
		$providerJoin: Boolean
		$with_aggregate: Boolean
		$switch: String
	) {
		tariffInAntiFilter(
			id: $id
			region: $region
			providerId: $providerId
			internet: $internet
			calls: $calls
			price: $price
			fix: $fix
			providerJoin: $providerJoin
			with_aggregate: $with_aggregate
			switch: $switch
		) {
			data {
				id
				name
				displayPrice
				utm_url
				mobile_new {
					internet
					calls
					internet_type
					calls_type
					tag_mobil {
						description
						name
						translit
					}
				}
				social_unlim {
					whatsapp
					telegram
					viber
					discord
					skype
					vk
					ok
					tiktok
					youtube
					snapchat
				}
				provider {
					id
					name
					logo
					logo_2
					url_name
					vip_provider
					contacts {
						card
						link
						phones
					}
					global {
						id
					}
					operator_settings {
						tariffs {
							value
							url
							button_text
						}
					}
				}
				dody {
					state
				}
			}
			aggregationTariffs {
				providers {
					id
				}
				internet
				calls
				price
			}
		}
	}
`;

export default TARIFF_IN_ANTI_FILTER;
